import { render } from "./InputUpload.vue?vue&type=template&id=54212cbb&scoped=true"
import script from "./InputUpload.vue?vue&type=script&lang=js"
export * from "./InputUpload.vue?vue&type=script&lang=js"

import "./InputUpload.vue?vue&type=style&index=0&id=54212cbb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54212cbb"]])

export default __exports__